import React from "react";
import { inject, observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";

import {
  Card,
  CircularProgress,
  Grid,
  Typography
} from "@material-ui/core";


import ChangePasswordForm from "../components/forms/ChangePasswordForm";

const styles = theme => ({
  settingsCard: {
    padding: theme.spacing(2),
  },
  backLinkIconWrapper: {
    lineHeight: 0,
    marginRight: theme.spacing(0.5)
  },
  backLink: {
    color: "rgba(0, 0, 0, 0.4)",
    textDecoration: "none"
  },
  pageName: {
    fontWeight: "bold"
  },
  addRoomButton: {
    margin: theme.spacing(1),
    marginRight: theme.spacing(0)
  },
  progressContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  viewSwitchButtonGroup: {
    backgroundColor: "rgba(102, 102, 102, 1.0)",
  }
});

class Settings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  setLoading(loading) {
    this.setState({ loading: loading });
  }

  componentDidMount() {
    this.setLoading(true);
    this.props.rootStore.bootstrap().then(() => this.setLoading(false));
  }

  render() {
    const classes = this.props.classes;

    if (this.state.loading) {
      return (
        <div className={classes.progressContainer}>
          <CircularProgress className={classes.progress} />
        </div>
      );
    }

    return (<>
      <Grid justify="space-between" alignItems="center" container>
        <Typography variant="h4" className={classes.pageName}>
          Settings
        </Typography>
      </Grid>
      <br />
      <Card className={ classes.settingsCard }>
      <Typography variant="h5">
        Change Password
      </Typography>
      <ChangePasswordForm user={ this.props.user } notifications={ this.props.rootStore.notificationStore } />
      </Card>
    </>)
  }
}

export default withRouter(
  withStyles(styles)(
    inject(stores => ({
      rootStore: stores.rootStore,
      user: stores.rootStore.authStore.user
    }))(observer(Settings))
  )
);
